import Vue from "vue";
import RulesAndRegulations from "./RulesAndRegulations.vue";

export function load() {
    const selector = "RulesAndRegulations-card-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
          createElement(RulesAndRegulations, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
